// Override localStorage.getItem BEFORE ANY IMPORTS

/* eslint-disable global-require */
import 'react-app-polyfill/ie9'; // For IE 9-11 support
import 'react-app-polyfill/ie11'; // For IE 11 support
import './polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
// import './index.css';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import * as serviceWorker from './serviceWorker';
import i18n from './i18n';
import { store, persistor } from './config/store/store';

ReactDOM.render(
    <Provider store={store}>
        <PersistGate persistor={persistor}>
            <I18nextProvider i18n={i18n}>
                <App />
            </I18nextProvider>
        </PersistGate>
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
